import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { CallInitiateRequest, CallPageResponse, CallResponse } from '../models/call.model';

@Injectable({ providedIn: 'root' })
export class CallApiService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.apiUrl}api/calls`;

  listCalls(page = 0, size = 20): Observable<CallPageResponse> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());
    return this.http.get<CallPageResponse>(this.base, { params });
  }

  getCallById(id: number): Observable<CallResponse> {
    return this.http.get<CallResponse>(`${this.base}/${id}`);
  }

  getCallBySid(callSid: string): Observable<CallResponse> {
    return this.http.get<CallResponse>(`${this.base}/sid/${callSid}`);
  }

  listByContact(contactId: number, page = 0, size = 20): Observable<CallPageResponse> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());
    return this.http.get<CallPageResponse>(`${this.base}/contact/${contactId}`, { params });
  }

  listByAgent(agentId: number, page = 0, size = 20): Observable<CallPageResponse> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());
    return this.http.get<CallPageResponse>(`${this.base}/agent/${agentId}`, { params });
  }

  initiateCall(req: CallInitiateRequest): Observable<CallResponse> {
    return this.http.post<CallResponse>(this.base, req);
  }
}
